import React, { useEffect, useState, useRef } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { Link, useNavigate, useParams } from "react-router-dom";
import iconCameraBlue from "assets/images/icon-camera-blue.svg";

import Breadcrumb from "react-bootstrap/Breadcrumb";
import {
  Button,
  Container,
  Row,
  Col,
  Nav,
  Navbar,
  Card,
  Badge,
  FormGroup,
  Spinner,
} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import ProfileEdit from "../../../src/assets/images/profile-edit.svg";
import DownloadIocon from "../../../src/assets/images/download-icon.svg";
import BlackPinIcon from "../../../src/assets/images/inspector-pin-icon.svg";
import InsepectionProfileImg from "../../../src/assets/images/profile-dummy.svg";
import storage from "../../helpers/storage";
import Loader from "../../components/common/Loader";
import phoneMask from "../../helpers/phoneMask";
import {
  generateSerialNumber,
  getDownloadFileName,
} from "../../helpers/common";
import { getSrDetails, downloadAllApi } from "../../services/inspectionRequest";
import moment from "moment";
import { toast } from "react-toastify";
import { MESSAGES } from "../../constants/messages";
import { nameBasedProtectedRoutes } from "../../router/protected";
import { downloadInvoiceApiCall } from "services/invoice";
import ImageTag from "../../components/common/ImageTag";
import {
  datetimeFormats,
  invoiceStatus,
  inspectionStatusGridClassAndLabelForCustomer,
  inspectionTyppeWithoutKey,
  inspectionStatusWithoutKey,
} from "constants/constants";
import { GOOGLE_MAP_URL } from "constants/paths";
import {
  downloadDeficiencyApiCall,
  downloadDocumentsApiCall,
} from "services/inspections";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { ViewPhotoGallery } from "./ViewPhotoGallery";

export const InspectionDetail = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [inspectionData, setInspectionData] = useState<any>([]);
  const [inspectionMachines, setInspectionMachines] = useState<any>([]);
  const userInformation: any = storage.getData("user-info");
  const [btnLoading, setBtnLoading] = useState(false);
  const [inspectionType, setInspectionType] = useState([]);
  const [openViewGallery, setOpenViewGallery] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [imagesSet, setImagesSet] = useState([]); 
  const userId = userInformation.id;

  let [data, setData] = useState("");
  let [userFullAddress, setUserFullAddress] = useState<String | null>();
  let [fullAddress, setFullAddress] = useState<String | null>();
  let { id } = useParams();
  useEffect(() => {
    if (storage.getToken() != null) {
      getSrInspectionData();
    }
  }, [id]);
  let [jobTime, setJobTime] = useState<any>(null);

  const getSrInspectionData = async () => {
    setLoading(true);
    if (id) {
      getSrDetails({ id })
        .then(async (response) => {
          setLoading(false);
          if (response?.data?.job_time) {
            setJobTime(new Date("2013-05-16 " + response?.data?.job_time));
          }
          setInspectionType(response?.inspectionType);
          const machines = response?.data?.Inspection_machines;
          const newData = await Promise.all(
            machines.map(async (obj: any) => {
              obj.inspecion_type_original = obj?.inspection_type;
              if (obj.inspection_type == "" || obj.inspection_type == null)
                return obj;
              const findValue = response?.inspectionType.find(
                (item: any) => item.key === obj.inspection_type
              );

              if (findValue) {
                return { ...obj, inspection_type: findValue.value };
              }
              return obj;
            })
          );
          setInspectionMachines(newData);
          setInspectionData(response?.data);
          const userCity = response?.data?.user?.city
            ? ", " + response?.data?.user?.city
            : "";
          const userState = response?.data?.user?.state
            ? ", " + response?.data?.user?.state?.title
            : "";
          const userZip = response?.data?.user?.zipcode
            ? " " + response?.data?.user?.zipcode
            : "";
          const userFullAddress =
            response?.data?.user?.address + userCity + userState + userZip;
          setUserFullAddress(userFullAddress);

          const city = response?.data?.city ? ", " + response?.data?.city : "";
          const state = response?.data?.state
            ? ", " + response?.data?.state?.title
            : "";
          const zip = response?.data?.zipcode
            ? " " + response?.data?.zipcode
            : "";
          const fullAddress = response?.data.address + city + state + zip;
          setFullAddress(fullAddress);
        })
        .catch((error) => {
          toast.error(error.response.data.message);
          navigate(-1);
          setLoading(false);
        });
    } else {
      toast.error(MESSAGES.noRecordFound);
    }
  };

  const downloadInvoice = (id: number) => {
    downloadInvoiceApiCall({ id })
      .then((response) => {
        
        window.open(response.data, "_blank");
      })
      .catch((error) => {
        toast.error(error.response.data.message);
      });
  };

  const handleDownloadAll = () => {
    setBtnLoading(true);
    downloadAllApi(id)
      .then(async (response) => {
        const filename = await getDownloadFileName(
          inspectionData.sr_number,
          inspectionData.user_id
        );
        setBtnLoading(false);
        if (response) {
          const blob = new Blob([response], { type: "application/zip" });
          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");

          link.setAttribute("download", filename);

          link.setAttribute("href", url);

          link.click();

          // document.body.removeChild(link);
          // URL.revokeObjectURL(url);
          //link.href = url;
          // link.download = filename? filename : inspectionData.sr_number+'.zip';
          // link.click();
          // Clean up the temporary anchor element
          URL.revokeObjectURL(url);
          link.remove();
        } else {
          toast.error(MESSAGES.somethingWentWrong);
        }
      })
      .catch((error) => {
        toast.error(MESSAGES.noDocumentFound);
        setBtnLoading(false);
      });
  };
  const openMachine = (machine_id: String) => {
    navigate(nameBasedProtectedRoutes.machineDetailForCustomer.path, {
      state: { machine_id: machine_id },
    });
  };

  const downloadReport = (machine_id: number, status: string) => {
    if (status == inspectionStatusWithoutKey.Completed) {
      downloadDocumentsApiCall(machine_id)
        .then((response) => {
          window.open(response.data, "_blank");
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
    } else {
      downloadDeficiencyApiCall(machine_id)
        .then((response) => {
          window.open(response.data, "_blank");
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
    }
  };

  const viewImageGalary = (images) =>{
    if(images.length > 0){
      const   updatedImages =  images.map((image) => {
          image.src = image.image_file;
          return image;
        });
        setImagesSet(updatedImages);
        setOpenViewGallery(true);
      }
      
  }

 
  const closeViewGallery = () => {
    setOpenViewGallery(false);
  };

  const downloadExcelReport = (url:string) => {
    const fileName = url.split('/').pop();
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    link.style.display = "none";
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  return (
    <>
      {!loading ? (
        <section className="profile-main pt-4 dashboard-content">
          <Container className="">
            <Row>
              <Col md={12} lg={12}>
                <Breadcrumb className="border-0 shadow-none mb-0">
                  <Breadcrumb.Item
                    className="fs-15 fw-semibold text-link"
                    href="Javascript:void(0)"
                    onClick={() =>
                      navigate(nameBasedProtectedRoutes.dashborad.path)
                    }
                  >
                    Dashboard
                  </Breadcrumb.Item>

                  <Breadcrumb.Item
                    active
                    className="fs-15 fw-semibold light-gray"
                  >
                    Inspection (
                    {generateSerialNumber(
                      inspectionData.created_at,
                      inspectionData.id,
                      "SR-"
                    )}
                    ) - Details
                  </Breadcrumb.Item>
                </Breadcrumb>
                <h1 className="fs-30 fw-bold mb-3 mt-2">
                  Inspection (
                  {generateSerialNumber(
                    inspectionData.created_at,
                    inspectionData.id,
                    "SR-"
                  )}
                  ) - Details
                </h1>
              </Col>
              {inspectionData?.inspector && (
                <Col md={12} className="d-flex mb-3">
                  <div className="inspection-profile me-2">
                    <img src={InsepectionProfileImg} />
                  </div>
                  <div>
                    <p className="mb-0 gray-color fs-16 fw-bold">
                      Inspector Assigned:
                    </p>
                    <h2 className="fs-25 fw-bold text-gray">
                      {inspectionData?.inspector
                        ? generateSerialNumber(
                            inspectionData?.inspector?.created_at,
                            inspectionData?.inspector?.id,
                            ""
                          )
                        : "-"}{" "}
                      - {inspectionData?.inspector?.full_name}
                    </h2>
                  </div>
                </Col>
              )}
            </Row>
            <Form>
              <Row>
                <Col md={12} lg={12}>
                  <Card className="border-0 mb-3">
                    <Card.Body className="br-10 p-4">
                      <Row className="">
                        <Col md={12} lg={9}>
                          <Row className="">
                            <Col md={6} lg={6} className="inspector-border">
                              <h2 className="fs-20 fw-bold ls-2 border-left-6 mb-3">
                                CUSTOMER INFORMATION
                              </h2>
                              <Row className="mt-3">
                                <Col md={12} lg={12}>
                                  <Row>
                                    <Col md={12} lg={12}>
                                      <Form.Group
                                        className="mb-3"
                                        controlId="formBasicEmail"
                                      >
                                        <Row>
                                          <Col md={4} lg={4}>
                                            <Form.Label className="fs-13 fw-bold text-default mb-0">
                                              Customer Name
                                            </Form.Label>
                                          </Col>
                                          <Col md={8} lg={8}>
                                            <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                              {inspectionData?.user?.full_name}
                                            </Form.Text>
                                          </Col>
                                        </Row>
                                      </Form.Group>
                                    </Col>
                                    <Col md={12} lg={12}>
                                      <Form.Group
                                        className="mb-3"
                                        controlId="formBasicEmail"
                                      >
                                        <Row>
                                          <Col md={4} lg={4}>
                                            <Form.Label className="fs-13 fw-bold text-default mb-0">
                                              Customer #
                                            </Form.Label>
                                          </Col>
                                          <Col md={8} lg={8}>
                                            <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                              {generateSerialNumber(
                                                inspectionData?.user
                                                  ?.created_at,
                                                inspectionData?.user?.id,
                                                ""
                                              )}
                                            </Form.Text>
                                          </Col>
                                        </Row>
                                      </Form.Group>
                                    </Col>
                                    <Col md={12} lg={12}>
                                      <Form.Group
                                        className="mb-3"
                                        controlId="formBasicEmail"
                                      >
                                        <Row>
                                          <Col md={4} lg={4}>
                                            <Form.Label className="fs-13 fw-bold text-default mb-0">
                                              Email
                                            </Form.Label>
                                          </Col>
                                          <Col md={8} lg={8}>
                                            <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                              {inspectionData?.user?.email}
                                            </Form.Text>
                                          </Col>
                                        </Row>
                                      </Form.Group>
                                    </Col>
                                    <Col md={12} lg={12}>
                                      <Form.Group
                                        className="mb-3"
                                        controlId="formBasicEmail"
                                      >
                                        <Row>
                                          <Col md={4} lg={4}>
                                            <Form.Label className="fs-13 fw-bold text-default mb-0">
                                              Address
                                            </Form.Label>
                                          </Col>
                                          <Col md={8} lg={8}>
                                            <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                              {userFullAddress}
                                            </Form.Text>
                                          </Col>
                                        </Row>
                                      </Form.Group>
                                    </Col>

                                    <Col md={12} lg={12}>
                                      <Form.Group
                                        className="mb-3"
                                        controlId="formBasicEmail"
                                      >
                                        <Row>
                                          <Col md={4} lg={4}>
                                            <Form.Label className="fs-13 fw-bold text-default mb-0">
                                              Phone
                                            </Form.Label>
                                          </Col>
                                          <Col md={8} lg={8}>
                                            <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                              {inspectionData?.user?.phone_no
                                                ? phoneMask(
                                                    inspectionData?.user
                                                      ?.phone_no
                                                  )
                                                : "-"}
                                            </Form.Text>
                                          </Col>
                                        </Row>
                                      </Form.Group>
                                    </Col>
                                    <Col md={12} lg={12}>
                                      <Form.Group
                                        className="mb-3"
                                        controlId="formBasicEmail"
                                      >
                                        <Row>
                                          <Col md={4} lg={4}>
                                            <Form.Label className="fs-13 fw-bold text-default mb-0">
                                              Cell No.
                                            </Form.Label>
                                          </Col>
                                          <Col md={8} lg={8}>
                                            <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                              {inspectionData?.user?.cell_no
                                                ? phoneMask(
                                                    inspectionData?.user
                                                      ?.cell_no
                                                  )
                                                : "-"}
                                            </Form.Text>
                                          </Col>
                                        </Row>
                                      </Form.Group>
                                    </Col>
                                    <Col md={12} lg={12}>
                                      <Form.Group
                                        className="mb-3"
                                        controlId="formBasicEmail"
                                      >
                                        <Row>
                                          <Col md={4} lg={4}>
                                            <Form.Label className="fs-13 fw-bold text-default mb-0">
                                              Fax
                                            </Form.Label>
                                          </Col>
                                          <Col md={8} lg={8}>
                                            <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                              {inspectionData?.user?.fax_no
                                                ? phoneMask(
                                                    inspectionData?.user?.fax_no
                                                  )
                                                : "-"}
                                            </Form.Text>
                                          </Col>
                                        </Row>
                                      </Form.Group>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </Col>
                            <Col md={6} lg={6}>
                              <h2 className="fs-20 fw-bold ls-2 border-left-6 mb-3">
                                JOB INFORMATION
                              </h2>
                              <Row>
                                <Col md={12} lg={12}>
                                  <Form.Group
                                    className="mb-3"
                                    controlId="formBasicEmail"
                                  >
                                    <Row>
                                      <Col md={4} lg={4}>
                                        <Form.Label className="fs-13 fw-bold text-default mb-0">
                                          Project Name
                                        </Form.Label>
                                      </Col>
                                      <Col md={8} lg={8}>
                                        <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                          {inspectionData.title}
                                        </Form.Text>
                                      </Col>
                                    </Row>
                                  </Form.Group>
                                </Col>
                                <Col md={12} lg={12}>
                                  <Form.Group
                                    className="mb-3"
                                    controlId="formBasicEmail"
                                  >
                                    <Row>
                                      <Col md={4} lg={4}>
                                        <Form.Label className="fs-13 fw-bold text-default mb-0">
                                          Address
                                        </Form.Label>
                                      </Col>
                                      <Col md={8} lg={8}>
                                        <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                          {fullAddress}
                                        </Form.Text>
                                      </Col>
                                    </Row>
                                  </Form.Group>
                                </Col>
                                <Col md={12} lg={12}>
                                  <Form.Group
                                    className="mb-3"
                                    controlId="formBasicEmail"
                                  >
                                    <Row>
                                      <Col md={4} lg={4}>
                                        <Form.Label className="fs-13 fw-bold text-default mb-0">
                                          Job Contact
                                        </Form.Label>
                                      </Col>
                                      <Col md={8} lg={8}>
                                        <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                          {inspectionData?.job_contact_no}
                                        </Form.Text>
                                      </Col>
                                    </Row>
                                  </Form.Group>
                                </Col>
                                <Col md={12} lg={12}>
                                  <Form.Group
                                    className="mb-3"
                                    controlId="formBasicEmail"
                                  >
                                    <Row>
                                      <Col md={4} lg={4}>
                                        <Form.Label className="fs-13 fw-bold text-default mb-0">
                                          Phone
                                        </Form.Label>
                                      </Col>
                                      <Col md={8} lg={8}>
                                        <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                          {inspectionData?.phone_no
                                            ? phoneMask(
                                                inspectionData?.phone_no
                                              )
                                            : "-"}
                                        </Form.Text>
                                      </Col>
                                    </Row>
                                  </Form.Group>
                                </Col>
                                <Col md={12} lg={12}>
                                  <Form.Group
                                    className="mb-3"
                                    controlId="formBasicEmail"
                                  >
                                    <Row>
                                      <Col md={4} lg={4}>
                                        <Form.Label className="fs-13 fw-bold text-default mb-0">
                                          Job Date
                                        </Form.Label>
                                      </Col>
                                      <Col md={8} lg={8}>
                                        <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                          {inspectionData.inspection_date
                                            ? moment(
                                                inspectionData.inspection_date
                                              ).format(
                                                datetimeFormats.separatedDate
                                              )
                                            : "-"}
                                        </Form.Text>
                                      </Col>
                                    </Row>
                                  </Form.Group>
                                </Col>
                                <Col md={12} lg={12}>
                                  <Form.Group
                                    className="mb-3"
                                    controlId="formBasicEmail"
                                  >
                                    <Row>
                                      <Col md={4} lg={4}>
                                        <Form.Label className="fs-13 fw-bold text-default mb-0">
                                          Job Time
                                        </Form.Label>
                                      </Col>
                                      <Col md={8} lg={8}>
                                        <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                          {jobTime
                                            ? moment(jobTime).format("h:m A")
                                            : "-"}
                                        </Form.Text>
                                      </Col>
                                    </Row>
                                  </Form.Group>
                                </Col>
                                <Col md={12} lg={12}>
                                  <Form.Group
                                    className="mb-3"
                                    controlId="formBasicEmail"
                                  >
                                    <Row>
                                      <Col md={4} lg={4}>
                                        <Form.Label className="fs-13 fw-bold text-default mb-0">
                                          PO No.
                                        </Form.Label>
                                      </Col>
                                      <Col md={8} lg={8}>
                                        <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                          {inspectionData.po_no}
                                        </Form.Text>
                                      </Col>
                                    </Row>
                                  </Form.Group>
                                </Col>
                                <Col md={12} lg={12}>
                                  <Form.Group
                                    className="mb-3"
                                    controlId="formBasicEmail"
                                  >
                                    <Row>
                                      <Col md={4} lg={4}>
                                        <Form.Label className="fs-13 fw-bold text-default mb-0">
                                          Ordered By
                                        </Form.Label>
                                      </Col>
                                      <Col md={8} lg={8}>
                                        <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                          {inspectionData.ordered_by}
                                        </Form.Text>
                                      </Col>
                                    </Row>
                                  </Form.Group>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </Col>
                        <Col md={12} lg={3}>
                          {inspectionData?.invoice ? (
                            <Card
                              className={
                                inspectionData?.invoice?.status ==
                                invoiceStatus.paid
                                  ? "card-bg card-border invoice-bg"
                                  : "card-bg card-border invoice-bg-due"
                              }
                            >
                              <Card.Body>
                                <Card.Title className="fs-16 fw-bold text-default ls-16">
                                  INVOICE DETAILS{" "}
                                  <span
                                    onClick={() =>
                                      downloadInvoice(
                                        inspectionData?.invoice?.id
                                      )
                                    }
                                    className="float-end"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <ImageTag src={DownloadIocon} />
                                  </span>
                                </Card.Title>
                                <Row>
                                  <Col md={12} lg={12}>
                                    <Form.Group
                                      className="mb-3"
                                      controlId="formBasicEmail"
                                    >
                                      <Form.Label className="fs-13 fw-bold text-default mb-0">
                                        Date
                                      </Form.Label>
                                      <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                        {inspectionData?.invoice?.invoice_date
                                          ? moment(
                                              inspectionData?.invoice
                                                ?.invoice_date
                                            ).format(
                                              datetimeFormats.separatedDate
                                            )
                                          : "-"}
                                      </Form.Text>
                                    </Form.Group>
                                  </Col>
                                  <Col md={12} lg={12}>
                                    <Form.Group
                                      className="mb-3"
                                      controlId="formBasicEmail"
                                    >
                                      <Form.Label className="fs-13 fw-bold text-default mb-0">
                                        Number
                                      </Form.Label>
                                      <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                        {inspectionData?.invoice?.invoice_number
                                          ? inspectionData?.invoice
                                              ?.invoice_number
                                          : "-"}
                                      </Form.Text>
                                    </Form.Group>
                                  </Col>
                                  <Col md={12} lg={12}>
                                    <Form.Group
                                      className="mb-3"
                                      controlId="formBasicEmail"
                                    >
                                      <Form.Label className="fs-13 fw-bold text-default mb-0">
                                        Amount
                                      </Form.Label>
                                      <Form.Text className="d-block form-text fs-16 fw-bold mt-0 text-default w-100">
                                        {/* inspectionData?.invoice?.amount
                                          ? "$" +
                                            inspectionData?.invoice?.amount
                                          : "-" */}
                                          {inspectionData?.invoice?.amount ? '$' + new Intl.NumberFormat('en-US').format(inspectionData.invoice.amount) : '-'}
                                      </Form.Text>
                                    </Form.Group>
                                  </Col>
                                  <Col md={12} lg={12}>
                                    {inspectionData?.invoice &&
                                    inspectionData?.invoice?.status ==
                                      invoiceStatus.paid ? (
                                      <div className="text-center bg-dark-green text-white fw-bold br-5 p-1">
                                        {" "}
                                        <i className="fas fa-check-circle fs-13"></i>{" "}
                                        Paid
                                      </div>
                                    ) : (
                                      <div className="text-center bg-dark-red text-white fw-bold br-5 p-1">
                                        {" "}
                                        <i className="fas fa-exclamation-circle fs-13"></i>{" "}
                                        {inspectionData?.invoice?.days_overdue >
                                        0
                                          ? inspectionData?.invoice
                                              ?.days_overdue
                                          : 0}{" "}
                                        days overdue
                                      </div>
                                    )}
                                  </Col>
                                </Row>
                              </Card.Body>
                            </Card>
                          ) : (
                            ""
                          )}
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>

                  <Card className="border-0 mb-3">
                    <div className="border-0 bg-default bg-theme black-color fs-20 fw-bold ls-2 btlr-14 btrr-14 pe-4 ps-4 pt-11 card-header d-flex justify-content-between align-items-center">
                      MACHINE INFORMATION
                      {btnLoading ? (
                        <div className="downloadAllBtn">
                          <Spinner size="sm" /> Downloading...
                        </div>
                      ) : (
                        <div
                          className="downloadAllBtn"
                          onClick={handleDownloadAll}
                        >
                          <i className="fa fa-download text-info"></i> Download
                          All
                        </div>
                      )}
                    </div>

                    <Card.Body className=" p-4 pe-4 ps-4 pt-4">
                      <Row className="">
                        <Col md={12} lg={12}>
                          <div className="table-responsive">
                            <table className="table custom-table border-none-table table-striped">
                              <thead>
                                <tr>
                                  <th>DEVICE ID</th>
                                  <th>MAKE</th>
                                  <th>MODEL NO.</th>
                                  <th>SERIAL NO.</th>
                                  <th>JOB LOCATION</th>
                                  <th>INSPECTION TYPE</th>
                                  <th>CERTIFICATE NO.</th>
                                  <th>ISSUE DATE</th>
                                  <th>STATUS</th>
                                  <th>ACTION</th>
                                </tr>
                              </thead>
                              <tbody>
                                {inspectionMachines?.map(
                                  (data: any, index: any) => (
                                    <tr key={index}>
                                      <td className="insepection-list-device-id">
                                      <OverlayTrigger overlay={
                                            <Tooltip>
                                              {data.device_id}
                                            </Tooltip>
                                          }
                                        >
                                          <span className="text-nobreak">
                                          {data.device_id}
                                          </span>
                                        </OverlayTrigger>
                                      </td>
                                      <td className="insepection-list-make">
                                        <OverlayTrigger overlay={
                                            <Tooltip>
                                              {data.make}
                                            </Tooltip>
                                          }
                                        >
                                          <span className="text-nobreak">
                                          {data.make}
                                          </span>
                                        </OverlayTrigger>
                                      </td>
                                      <td className="insepection-list-make">
                                        <OverlayTrigger overlay={
                                            <Tooltip>
                                              {data.model_number
                                          ? data.model_number
                                          : "-"}
                                            </Tooltip>
                                          }
                                        >
                                          <span className="text-nobreak">
                                          {data.model_number
                                          ? data.model_number
                                          : "-"}
                                          </span>
                                        </OverlayTrigger>
                                        
                                      </td>
                                      <td className="insepection-list-make">
                                      <OverlayTrigger overlay={
                                            <Tooltip>
                                              {data.serial_number}
                                            </Tooltip>
                                          }
                                        >
                                          <span className="text-nobreak">
                                          {data.serial_number}
                                          </span>
                                        </OverlayTrigger>
                                        </td>
                                      <td className="ps-10">
                                        <OverlayTrigger
                                          overlay={
                                            <Tooltip>
                                              {data.job_location}
                                            </Tooltip>
                                          }
                                        >
                                          <span
                                            role="button"
                                            className="d-inline-block"
                                          >
                                            <Link
                                              target="_blank"
                                              to={`${GOOGLE_MAP_URL}${data?.job_location}`}
                                            >
                                              <ImageTag
                                                src={BlackPinIcon}
                                                alt="pin icon"
                                              />
                                            </Link>
                                          </span>
                                        </OverlayTrigger>
                                      </td>
                                      <td>{data.inspection_type}</td>
                                      <td>
                                        {data.inspecion_type_original ==
                                          inspectionTyppeWithoutKey.Annual ||
                                        data.inspecion_type_original ==
                                          inspectionTyppeWithoutKey.Prepurchase ||
                                        data.inspecion_type_original ==
                                          inspectionTyppeWithoutKey.Maritime
                                          ? data?.certificate
                                              ?.certificate_number
                                            ? data?.certificate
                                                ?.certificate_number
                                            : "-"
                                          : "-"}
                                      </td>
                                      <td>
                                        {data?.certificate?.issue_date
                                          ? moment(
                                              data?.certificate?.issue_date
                                            ).format(
                                              datetimeFormats.separatedDate
                                            )
                                          : "-"}
                                      </td>
                                      <td>
                                        {data?.service_status ? (
                                          <span
                                            className={`${
                                              inspectionStatusGridClassAndLabelForCustomer[
                                                data?.service_status as keyof typeof inspectionStatusGridClassAndLabelForCustomer
                                              ]["class"]
                                            } text-center br-5 p-1 pe-2 ps-2 fs-15 d-inline-block`}
                                          >
                                            {
                                              inspectionStatusGridClassAndLabelForCustomer[
                                                data?.service_status as keyof typeof inspectionStatusGridClassAndLabelForCustomer
                                              ]["label"]
                                            }
                                          </span>
                                        ) : (
                                          ""
                                        )}
                                        <span className="d-none text-center bg-ligt-green text-green br-5 p-1 pe-2 ps-2  fs-15 d-inline-block">
                                          Completed
                                        </span>
                                        <span className="d-none text-center bg-light-red text-red br-5 p-1 pe-2 ps-2  fs-15 d-inline-block">
                                          Deficient
                                        </span>
                                        <span className="d-none text-center bg-light-sky text-sky br-5 p-1 pe-2 ps-2  fs-15 d-inline-block">
                                          Docs In Process
                                        </span>
                                      </td>
                                      <td className="min-width100">
                                        {data.machine_images.length > 0 &&  
                                        
                                        <a
                                        href="javascript:void(0)"
                                        className="me-3"
                                      >
                                        <OverlayTrigger
                                          overlay={<Tooltip>View Image</Tooltip>}
                                        >
                                          <ImageTag
                                            src={iconCameraBlue}
                                            onClick={()=>viewImageGalary(data.machine_images)}
                                          />
                                        </OverlayTrigger>
                                      </a>
                                      }
                                        {(data.service_status ==
                                          inspectionStatusWithoutKey.DefiReportWaiting ||
                                          data.service_status ==
                                            inspectionStatusWithoutKey.DefiReportReceived ||
                                          data.service_status ==
                                            inspectionStatusWithoutKey.Completed) &&
                                          (data.inspecion_type_original ==
                                            inspectionTyppeWithoutKey.Annual ||
                                            data.inspecion_type_original ==
                                              inspectionTyppeWithoutKey.Prepurchase ||
                                            data.inspecion_type_original ==
                                              inspectionTyppeWithoutKey.Maritime) && (
                                            <span
                                              onClick={() => {
                                                downloadReport(
                                                  data.id,
                                                  data.service_status
                                                );
                                              }}
                                              className="text-link me-3"
                                            >
                                              <img src={DownloadIocon} />
                                            </span>
                                          )}

                                        {data.service_status ==
                                          inspectionStatusWithoutKey.DefiReportWaiting &&
                                          (data.inspecion_type_original ==
                                            inspectionTyppeWithoutKey.Annual ||
                                            data.inspecion_type_original ==
                                              inspectionTyppeWithoutKey.Prepurchase ||
                                            data.inspecion_type_original ==
                                              inspectionTyppeWithoutKey.Maritime) && (
                                            <span
                                              onClick={() => {
                                                openMachine(data.id);
                                              }}
                                              className="text-link "
                                            >
                                              <ImageTag src={ProfileEdit} />
                                            </span>
                                          )}

                                          { data?.certificate?.excel_dataset  && 
                                            (<OverlayTrigger
                                              overlay={<Tooltip>Download DataSet</Tooltip>}
                                            >
                                              <i
                                              className="pointer-cursor fas fa fa-file-excel mx-2"
                                              onClick={() => {
                                                downloadExcelReport(data?.certificate?.excel_dataset);
                                              }}
                                            />
                                            </OverlayTrigger>
                                            )}
                                          
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>

                  {inspectionData?.additional_notes && (
                    <Card className="border-0 mb-3 bg-none">
                      <Card.Body className="br-10 pt-2 pe-0 ps-0 card-body">
                        <h2 className="fs-20 fw-bold ls-2 mb-3">NOTES</h2>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: inspectionData?.additional_notes?.replace(
                              /\n/g,
                              "<br>"
                            ),
                          }}
                        ></p>
                      </Card.Body>
                    </Card>
                  )}
                  {openViewGallery && (

                    <ViewPhotoGallery images={imagesSet} openViewGallery={openViewGallery} closeViewGallery={closeViewGallery} />
                   
                  )}
                </Col>
              </Row>
            </Form>
          </Container>
        </section>
      ) : (
        ""
      )}

      <Loader isLoading={loading} />
    </>
  );
};
